// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowDownRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowDownRightIcon" ref={forwardedRef} {...props}>
      <path d="m13.402 14.145-8.5-.007v-1.502l5.879.005-5.586-5.586 1.059-1.059 5.647 5.648-.001-6 1.495.001z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowDownRightIcon = /* @__PURE__ */ Object.assign(
  ArrowDownRightIconComponent,
  { displayName: 'ArrowDownRightIcon' },
);
